enum AccountRoutesAPI {
  USER_ACCOUNT_ACTIVATION = '/customer-portal-service/public/Activate',
  USER_RECOVER_PASSWORD = '/customer-portal-service/public/RecoverPassword'
}

export {
  AccountRoutesAPI,
};
